import globals from "web/script/modules/globals";
import environment from "web/script/modules/environment";
import url from "web/script/utils/url";
import SignupOverlay from "web/script/components/overlays/signup-overlay";

export default {
    enter(path, queryParams, parent) {
        // If we already have a signup-overlay component rendered return it
        const loginOverlayComponent = parent.findComponent("login-overlay");
        const SignupOverlayComponent = parent.findComponent("signup-overlay");
        if (SignupOverlayComponent || loginOverlayComponent) {
            return SignupOverlayComponent;
        }

        // If we're already on a signup page then return
        const isNewSignupPage = parent.el.querySelector(".signup-overlay");
        if (isNewSignupPage) {
            return parent.findComponent("default-layout");
        }

        // If we're already on a login page then redirect or return
        const isLoginPage = parent.el.querySelector(".login-overlay");
        if (isLoginPage) {
            return parent.findComponent("default-layout");
        }

        const formType = environment.get("formType", "unknown");
        const loginSuccessRedirectUrl = environment.get("loginSuccessRedirectUrl", "/app/");

        // We're not already on a login or signup page so show the overlay
        let signupOverlay = new SignupOverlay({
            path,
            queryParams,
            formType,
            loginSuccessRedirectUrl,
            isOverlay: true,
        });
        signupOverlay.appendTo(parent);

        // Return a promise that resolves once the overlay is opened
        return signupOverlay.open().then(function() {
            return signupOverlay;
        });
    },

    update(path, queryParams, component) {
        const isNewSignupPage = component.name === "signup-overlay";
        const isLoginPage = component.name === "login-overlay";
        if (isNewSignupPage || isLoginPage) {
            return;
        } else {
            // On a signup page and want to redirect to the correct
            // page To handle the case where we're on
            // /account/register/ and click the save for later button
            // want to redirect to render the save for later version
            // of the same page.
            globals.window.location = url.unparse({
                path,
                searchParams: queryParams,
            });
        }
    },

    exit(path, queryParams, component) {
        if (component) {
            if (component.name === "signup-overlay" || component.name === "login-overlay") {
                return component.close();
            }
        }
    },
};
